import { PageSEO } from '@/components/SEO';

export default function Vilkar() {
  return (
    <div>
      <PageSEO title="Vilkår" path="/vilkar" description="Vilkår og betingelser for tjenester fra Side Kraft. Nettsider, SEO, annonsering. Les vilkårene før du bestiller." />
      {/* Hero Section */}
      <section className="pt-16 md:pt-20 pb-16 md:pb-20 bg-muted" data-testid="vilkar-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <p className="font-manrope text-xs font-medium tracking-[0.3em] uppercase text-accent mb-4">
              Juridisk
            </p>
            <h1 className="font-syne font-bold text-5xl md:text-6xl text-primary tracking-tight leading-[0.95]">
              Vilkår og betingelser
            </h1>
            <p className="font-manrope text-lg text-muted-foreground mt-8 leading-relaxed">
              Sist oppdatert: Januar 2026
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 md:py-32" data-testid="vilkar-content">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <div className="space-y-12">
            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                1. Generelt
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Disse vilkårene og betingelsene gjelder for alle tjenester levert av Side Kraft. Ved å benytte våre tjenester aksepterer du disse vilkårene. Vilkårene kan endres uten forvarsel, og gjeldende vilkår vil alltid være tilgjengelige på vår nettside.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                2. Tjenester
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed mb-4">
                Side Kraft tilbyr følgende tjenester:
              </p>
              <ul className="font-manrope text-muted-foreground space-y-2 list-disc list-inside">
                <li>Utvikling og design av nettsider</li>
                <li>Søkemotoroptimalisering (SEO)</li>
                <li>Digital annonsering og markedsføring</li>
                <li>Utvikling av nettbutikker</li>
                <li>Logodesign og visuell identitet</li>
                <li>Google Bedriftsprofil-optimalisering</li>
              </ul>
              <p className="font-manrope text-muted-foreground leading-relaxed mt-4">
                Omfanget av hver tjeneste avtales individuelt og dokumenteres i egen avtale eller tilbud.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                3. Priser og betaling
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed mb-4">
                Alle priser oppgis eksklusiv merverdiavgift (MVA) med mindre annet er avtalt. Betalingsbetingelser:
              </p>
              <ul className="font-manrope text-muted-foreground space-y-2 list-disc list-inside">
                <li>Faktura forfaller 14 dager etter fakturadato</li>
                <li>Ved forsinket betaling påløper forsinkelsesrente i henhold til forsinkelsesrenteloven</li>
                <li>For større prosjekter kan det avtales delbetaling</li>
                <li>Løpende tjenester faktureres månedlig forskuddsvis</li>
              </ul>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                4. Kundens forpliktelser
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed mb-4">
                Kunden forplikter seg til å:
              </p>
              <ul className="font-manrope text-muted-foreground space-y-2 list-disc list-inside">
                <li>Levere nødvendig materiale og informasjon i tide</li>
                <li>Gi tilbakemelding innen avtalte frister</li>
                <li>Sørge for at all informasjon som gis er korrekt og lovlig</li>
                <li>Respektere opphavsrett og immaterielle rettigheter</li>
              </ul>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                5. Leveranse og frister
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Leveringsfrister avtales for hvert prosjekt og dokumenteres i avtale eller tilbud. Forsinkelser som skyldes kundens manglende leveranse av materiale eller tilbakemelding vil kunne medføre tilsvarende forsinkelse i vår leveranse. Vi forbeholder oss retten til å justere frister ved vesentlige endringer i prosjektets omfang.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                6. Immaterielle rettigheter
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Alle immaterielle rettigheter til det leverte arbeidet overføres til kunden ved full betaling, med unntak av generelle metoder, teknikker og verktøy som Side Kraft har utviklet. Vi forbeholder oss retten til å benytte leveranser som referanseprosjekter i vår markedsføring, med mindre annet er avtalt.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                7. Ansvarsbegrensning
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Side Kraft er ikke ansvarlig for indirekte tap, følgeskader eller tap av fortjeneste. Vårt samlede ansvar er begrenset til det beløp som er betalt for den aktuelle tjenesten. Vi er ikke ansvarlig for forsinkelser eller mangler som skyldes forhold utenfor vår kontroll (force majeure).
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                8. Oppsigelse
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Løpende avtaler kan sies opp med én måneds skriftlig varsel med mindre annet er avtalt. Ved oppsigelse faktureres utført arbeid frem til oppsigelsestidspunktet. Prosjektbaserte oppdrag kan avsluttes ved gjensidig avtale, hvor allerede utført arbeid honoreres.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                9. Konfidensialitet
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Begge parter forplikter seg til å behandle all konfidensiell informasjon fortrolig. Dette inkluderer forretningshemmeligheter, kundedata og andre sensitive opplysninger. Denne forpliktelsen gjelder også etter avtalens opphør.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                10. Tvister
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                Eventuelle tvister skal søkes løst gjennom forhandlinger. Dersom partene ikke kommer til enighet, skal tvisten avgjøres ved de alminnelige domstoler med Oslo tingrett som verneting. Norsk lov gjelder for alle forhold mellom partene.
              </p>
            </div>

            <div>
              <h2 className="font-syne font-bold text-2xl text-primary mb-4">
                11. Kontakt
              </h2>
              <p className="font-manrope text-muted-foreground leading-relaxed">
                For spørsmål om disse vilkårene, ta kontakt med oss:
              </p>
              <ul className="font-manrope text-muted-foreground mt-4 space-y-2">
                <li>E-post: post@sidekraft.no</li>
                <li>Telefon: +47 400 81 956</li>
                <li>Adresse: Oslo, Norge</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
